import { render, staticRenderFns } from "./SliderImg.vue?vue&type=template&id=1e00dd43"
import script from "./SliderImg.vue?vue&type=script&lang=js"
export * from "./SliderImg.vue?vue&type=script&lang=js"
import style0 from "./SliderImg.vue?vue&type=style&index=0&id=1e00dd43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports